"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pulse = exports.gtm = void 0;

/**
 * Since we are going to try to import the tracking plugins in a few places we will centralize the
 * attempt here.
 */
var gtm;
exports.gtm = gtm;

try {
  exports.gtm = gtm = require('@blocket/tracking-gtm');
} catch (_unused) {
  exports.gtm = gtm = {
    update: function update() {},
    event: function event() {},
    pageView: function pageView() {}
  };
}

var pulse;
exports.pulse = pulse;

try {
  exports.pulse = pulse = require('@blocket/tracking-pulse');
} catch (_unused2) {
  exports.pulse = pulse = {
    update: function update() {},
    event: function event() {},
    pageView: function pageView() {}
  };
}
//# sourceMappingURL=trackers.js.map